import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { faFlag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './ObjectiveFlag.module.css';
import { CommonButton } from '_components';
import { alertActions, noteActions } from '_actions';


class ObjectiveFlag extends React.Component {

    flagClick() {
        if (this.props.noteType === 1 || this.props.noteType === 3 || this.props.noteType === 5) {
            this.assessmentFlagClick();
            this.stgFlagClick();
        }
    }

    stgFlagClick() {
        if (this.props.existingShortGoalKey) {
            this.props.removeChildRow(this.props.noteId, 'PTSHORTGOALS', 'SG', parseInt(this.props.existingShortGoalKey));
            alertActions.successMsg('Successfully removed item from Goals.')
        } else {
            if (!this.props.existingFlagKey)
                this.props.addSTGFlag(this.props.noteId, this.props.flagText, 'false', this.props.stgDateDefault, this.props.epno);
        }
    }

    assessmentFlagClick() {
        if (this.props.existingFlagKey) {
            this.props.removeChildRow(this.props.noteId, 'PTASSESSMENTFLAGS', 'AF', parseInt(this.props.existingFlagKey));
            alertActions.successMsg('Successfully removed item from Goals.')
        } else {
            this.props.addAssessmentFlag(this.props.noteId, this.props.asno, this.props.mopno, this.props.flagText);
        }
    }

    render() {
        let cls;
        if ((this.props.noteType === 1 || this.props.noteType === 3 || this.props.noteType === 5) && !this.props.previousExistingSTG) {
            cls = (this.props.existingFlagKey || this.props.existingShortGoalKey) ? styles.existing : styles.button;
        } else {
            cls = (this.props.existingFlagKey || this.props.existingShortGoalKey) ?  styles.existing_no_link : styles.button_no_link;
        }  

        return (
            <span className={this.props.className}>
                {this.props.flagged && ((this.props.noteType === 1 || this.props.noteType === 3 || this.props.noteType === 5) && !this.props.previousExistingSTG)  &&
                    <CommonButton title={(this.props.existingFlagKey || this.props.existingShortGoalKey) ? 'Remove from Goals' : 'Add to Goals'} onClick={() => this.flagClick()} size={this.props.size ? this.props.size : 'extra-small'} className={cls}>
                        <FontAwesomeIcon icon={faFlag} transform="shrink-6" color="white" />
                    </CommonButton>
                }
                {this.props.flagged && ((this.props.noteType !== 1 && this.props.noteType !== 3 && this.props.noteType !== 5) || this.props.previousExistingSTG) &&
                    <CommonButton title={(this.props.existingFlagKey || this.props.existingShortGoalKey) ? 'Existing Goal' : 'Unable to add on this note type'} size={this.props.size ? this.props.size : 'extra-small'} className={cls}>
                        <FontAwesomeIcon icon={faFlag} transform="shrink-6" color="white" />
                    </CommonButton>
                }
                {!this.props.flagged &&
                    <span className={cls} />
                }
            </span>
        );
    }
}



function mapDispatchToProps(dispatch) {
    return {
        addAssessmentFlag: bindActionCreators(noteActions.addAssessmentFlag, dispatch),
        addSTGFlag: bindActionCreators(noteActions.addSTGFlag, dispatch),
        successMsg: bindActionCreators(alertActions.successMsg, dispatch),
        removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let asno = parseInt(Object.keys(state.entities.notes.PTASSESSMENT)
        .find(key => (state.entities.notes.PTASSESSMENT[key].ASEVNO === pk && noteType === 1)
            || (state.entities.notes.PTASSESSMENT[key].ASNTNO === pk && noteType !== 1)));

    let stgDateDefault = state.ui.notes[noteId].stgDateDefault;
    
    let existingFlagKey = Object.keys(state.entities.notes.PTASSESSMENTFLAGS)
        .find(key => {
            return (state.entities.notes.PTASSESSMENTFLAGS[key].AFASNO === asno &&
                ((ownprops.mopno && state.entities.notes.PTASSESSMENTFLAGS[key].AFMOPNO === ownprops.mopno) ||
                    (ownprops.mopno === undefined && state.entities.notes.PTASSESSMENTFLAGS[key].AFFLAGTEXT === ownprops.flagText)))
        });

    let existingShortGoalKey = Object.keys(state.entities.notes.PTSHORTGOALS)
        .find(key => {
            return (state.entities.notes.PTSHORTGOALS[key].NoteId === noteId && state.entities.notes.PTSHORTGOALS[key].SGNAME === ownprops.flagText)
        });

    let previousExistingSTG =  Object.keys(state.entities.notes.PTSHORTGOALS)
    .find(key => {
        return (state.entities.notes.PTSHORTGOALS[key].NoteId === noteId && state.entities.notes.PTSHORTGOALS[key].SGNAME === ownprops.flagText && state.entities.notes.PTSHORTGOALS[key].SGSGNO)
    });

    return {
        noteId: noteId,
        noteType: noteType,
        asno: asno,
        existingFlagKey: existingFlagKey,
        existingShortGoalKey,
        stgDateDefault,
        previousExistingSTG,
        epno
    };
}

const connectedObjectiveFlag = connect(mapStateToProps, mapDispatchToProps)(ObjectiveFlag);
export { connectedObjectiveFlag as ObjectiveFlag };
